import { css } from 'aphrodite';
import * as React from 'react';
import HorizontalBarChart from './charts/HorizontalBarChart';
import { TrendItem, buildTrendItem } from 'src/models/TrendItem';
import { TrendChart } from './charts/TrendChart';
import { ChartItem } from 'src/models/ChartItem';
import { Card, CardHeader, CardBody, ListGroup, ListGroupItem, Modal, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, } from 'reactstrap';
import { PublicationListItem } from 'src/models/PublicationListItem';
import { styles } from 'src/styles/AuthorPublications';
import { Author} from "src/models/CoAuthor";
import axios from "axios";
import { sortTrend } from 'src/models/TrendItem';
import { buildTrendItemExp } from '../models/TrendItem';
import { sortItem } from 'src/mobx/FacultyPageStore';
import { appStore } from 'src/mobx/AppStore';
import { RequestState } from 'src/models/RequestState';
import { Api } from '../core/api';
import { observer, inject } from 'mobx-react';
import millify from "millify";
import { CombinedInfo } from './CombinedInfo';
import { JsonConvert } from 'json2typescript';
import { ProposalTrendItem } from 'src/models/ProposalTrendItem';
import { StackedTrendChart } from './charts/StackedTrendChart';
import { StackedTrendItem } from 'src/models/StackedTrendItem';
import { ProposalByFundingAgencyItem } from 'src/models/ProposalByFundingAgencyItem';
import { ProposalByDepartmentItem } from 'src/models/ProposalByDepartmentItem';
import StackedHorizontalBarChart from './charts/StackedHorizontalBarChart';
import { StackedChartItem } from 'src/models/StackedChartItem';
import { ProposalListItem, ProposalParticipant, ProposalProjectItem } from 'src/models/ProposalListItem';
import { ChartStore } from 'src/mobx/ChartStore';
import { ProposalDetailDialog } from './dialogs/ProposalDetailDialog';
import { URLBuilder } from 'src/core/URLBuilder';
import { AbbreviationItem } from 'src/models/AbbreviationItem';


interface IAuthorProposalProps {
    author_id: string;
    first_name: string;
    last_name: string;
}

class AuthorProposalState {
    public readonly selected_co_investigators_tab: number;
    public readonly isTrendBarSelected: boolean;
    public readonly selectedYear: number;
    public readonly modal: boolean;
    public readonly isProjectExpanded: boolean;
    public readonly isDepartmentExpanded: boolean;
    public readonly isProjectDetailDialogOpen: boolean;
    public readonly clickedProjectID: string;
    public readonly showCount: boolean;
    public readonly startYear: number;
    public readonly endYear: number;
    public readonly isProposalDialogOpen: boolean = false;
    public readonly clickedProposalListItem: ProposalListItem;

    constructor(){
        this.selected_co_investigators_tab = 0;
        this.isTrendBarSelected = false;
        this.selectedYear = 0;
        this.modal = false;
        this.isProjectExpanded = false;
        this.isDepartmentExpanded = false;
        this.isProjectDetailDialogOpen= false;
        this.clickedProjectID = "";
        this.showCount = false;
        this.startYear = new Date().getFullYear() - 5;
        this.endYear = new Date().getFullYear();
    }
}


@inject('store')
@observer
export class AuthorProposals extends React.Component<IAuthorProposalProps, AuthorProposalState> {
    
    public static defaultProps = {
        author_id: "89",
    };

    constructor(props: IAuthorProposalProps) {
        super(props)
        this.state = new AuthorProposalState();     
    }
   
    public async componentDidMount() {
        const author_id = this.props.author_id;
        if(this.state.isTrendBarSelected){
            this.fetchAllData(this.state.selectedYear);
        }else{
            this.fetchDataForRange(this.state.startYear, this.state.endYear);
        }
    }
    
    private fetchAllData = (year: number) => {
        this.fetchProposalsOverTime(year);
        this.fetchData(year);
    }

    private fetchData = (year: number) => {
        this.fetchProposalByDepartment(year);
        this.fetchProposalByFundingAgency(year);
        this.fetchProposalListForAuthor(year);
    }

    private fetchDataForRange = (startYear: number, endYear: number) => {
        this.fetchProposalsOverTimeForRange(startYear, endYear);
        this.fetchProposalByDepartmentForRange(startYear, endYear);
        this.fetchProposalByFundingAgencyForRange(startYear, endYear);
        this.fetchProposalListForAuthorForRange(startYear, endYear);
    }

    private fetchProposalsOverTime = (year: number) => {
        const proposalsData = appStore.facultyPageStore.authorPageData.proposalData;
        proposalsData.proposals_over_time.setRequestState(RequestState.LOADING);
        const url = URLBuilder.proposals_over_time(this.props.author_id)
        axios.get(url).then((res)=> {
            if(res.status === 200){
                try{
                    const jsonConvert = new JsonConvert();
                    const data = jsonConvert.deserializeArray(res.data,ProposalTrendItem);
                    proposalsData.proposals_over_time.setData(data);
                }catch(error){
                    proposalsData.proposals_over_time.setError(error.toString());
                }
            }else{
                const error = res.statusText + ":" + res.data
                proposalsData.proposals_over_time.setError(error);
            }    
        }).catch((err)=>{
            proposalsData.proposals_over_time.setError(err.toString());
        });
    }

    private fetchProposalsOverTimeForRange = (startYear: number, endYear: number) => {
        const proposalsData = appStore.facultyPageStore.authorPageData.proposalData;
        proposalsData.proposals_over_time.setRequestState(RequestState.LOADING);
        const url = URLBuilder.proposals_over_time_for_range(this.props.author_id, startYear, endYear)
        axios.get(url).then((res)=> {
            if(res.status === 200){
                try{
                    const jsonConvert = new JsonConvert();
                    const data = jsonConvert.deserializeArray(res.data,ProposalTrendItem);
                    proposalsData.proposals_over_time.setData(data);
                }catch(error){
                    proposalsData.proposals_over_time.setError(error.toString());
                }
            }else{
                const error = res.statusText + ":" + res.data
                proposalsData.proposals_over_time.setError(error);
            }    
        }).catch((err)=>{
            proposalsData.proposals_over_time.setError(err.toString());
        });
    }

    private fetchProposalByFundingAgency = (year: number) => {
        const proposalsData = appStore.facultyPageStore.authorPageData.proposalData;
        proposalsData.proposals_by_fundingagency.setRequestState(RequestState.LOADING);
        const url = URLBuilder.proposals_by_fundingagency(this.props.author_id, year)
        axios.get(url).then((res)=> {
            if(res.status === 200){
                try{
                    const jsonConvert = new JsonConvert();
                    const data = jsonConvert.deserializeArray(res.data, ProposalByFundingAgencyItem);
                    proposalsData.proposals_by_fundingagency.setData(data);
                }catch(error){
                    proposalsData.proposals_by_fundingagency.setError(error.toString());
                }
            }else{
                const error = res.statusText + ":" + res.data;
                proposalsData.proposals_by_fundingagency.setError(error);
            }    
        }).catch((err)=>{
            proposalsData.proposals_by_fundingagency.setError(err.toString());
        });
    }


    private fetchProposalByFundingAgencyForRange = (startYear: number, endYear: number) => {
        const proposalsData = appStore.facultyPageStore.authorPageData.proposalData;
        proposalsData.proposals_by_fundingagency.setRequestState(RequestState.LOADING);
        const url = URLBuilder.proposals_by_fundingagency_for_range(this.props.author_id, startYear, endYear);
        axios.get(url).then((res)=> {
            if(res.status === 200){
                try{
                    const jsonConvert = new JsonConvert();
                    const data = jsonConvert.deserializeArray(res.data, ProposalByFundingAgencyItem);
                    proposalsData.proposals_by_fundingagency.setData(data);
                }catch(error){
                    proposalsData.proposals_by_fundingagency.setError(error.toString());
                }
            }else{
                const error = res.statusText + ":" + res.data;
                proposalsData.proposals_by_fundingagency.setError(error);
            }    
        }).catch((err)=>{
            proposalsData.proposals_by_fundingagency.setError(err.toString());
        });
    }


    private fetchProposalByDepartment = (year: number) => {
        const proposalsData = appStore.facultyPageStore.authorPageData.proposalData;
        proposalsData.proposals_by_department.setRequestState(RequestState.LOADING);
        const url = URLBuilder.proposals_by_department(this.props.author_id, year)
        axios.get(url).then((res)=> {
            if(res.status === 200){
                try{
                    const jsonConvert = new JsonConvert();
                    const data = jsonConvert.deserializeArray(res.data, ProposalByDepartmentItem);
                    proposalsData.proposals_by_department.setData(data);
                }catch(error){
                    proposalsData.proposals_by_department.setError(error.toString());
                }
            }else{
                const error = res.statusText + ":" + res.data;
                proposalsData.proposals_by_department.setError(error);
            }    
        }).catch((err)=>{
            proposalsData.proposals_by_department.setError(err.toString());
        });

    }

    private fetchProposalByDepartmentForRange = (startYear: number, endYear: number) => {
        const proposalsData = appStore.facultyPageStore.authorPageData.proposalData;
        proposalsData.proposals_by_department.setRequestState(RequestState.LOADING);
        const url = URLBuilder.proposals_by_department_for_range(this.props.author_id, startYear, endYear);
        axios.get(url).then((res)=> {
            if(res.status === 200){
                try{
                    const jsonConvert = new JsonConvert();
                    const data = jsonConvert.deserializeArray(res.data, ProposalByDepartmentItem);
                    proposalsData.proposals_by_department.setData(data);
                }catch(error){
                    proposalsData.proposals_by_department.setError(error.toString());
                }
            }else{
                const error = res.statusText + ":" + res.data;
                proposalsData.proposals_by_department.setError(error);
            }    
        }).catch((err)=>{
            proposalsData.proposals_by_department.setError(err.toString());
        });

    }

    private fetchProposalListForAuthor = (year: number) => {
        const proposalsData = appStore.facultyPageStore.authorPageData.proposalData;
        proposalsData.proposals_list.setRequestState(RequestState.LOADING)
        const url = URLBuilder.proposals_for_faculty(this.props.author_id, year);
        axios.get(url).then((res)=> {
            if(res.status === 200){
                try{
                    const jsonConvert = new JsonConvert();
                    const data = jsonConvert.deserializeArray(res.data, ProposalListItem);
                    proposalsData.proposals_list.setData(data);
                }catch(error){
                    proposalsData.proposals_list.setError(error.toString());
                }
            }else{
                const error = res.statusText + ":" + res.data;
                proposalsData.proposals_list.setError(error);
            }    
        }).catch((err)=>{
            proposalsData.proposals_list.setError(err.toString());
        });

    }

    private fetchProposalListForAuthorForRange = (startYear: number, endYear: number) => {
        const proposalsData = appStore.facultyPageStore.authorPageData.proposalData;
        proposalsData.proposals_list.setRequestState(RequestState.LOADING);
        const url = URLBuilder.proposals_for_faculty_for_range(this.props.author_id, startYear, endYear)
        axios.get(url).then((res)=> {
            if(res.status === 200){
                try{
                    const jsonConvert = new JsonConvert();
                    const data = jsonConvert.deserializeArray(res.data, ProposalListItem);
                    proposalsData.proposals_list.setData(data);
                }catch(error){
                    proposalsData.proposals_list.setError(error.toString());
                }
            }else{
                const error = res.statusText + ":" + res.data;
                proposalsData.proposals_list.setError(error);
            }    
        }).catch((err)=>{
            proposalsData.proposals_list.setError(err.toString());
        });
    }

    public render() {
        return (
            <React.Fragment>
                <div id="div_content" className={css(styles.content)} >
                        {this.renderOverview()}
                        {this.renderCharts()}
                </div>
                {this.buildProjectExpandDialog()}
                {this.buildDepartmentExpandDialog()}
                {this.buildProjectDetailDialog()}
                {this.buildProposalDetailDialog()}
            </React.Fragment>
            
        );
    }

    public renderOverview = () => {

        const proposalsData = appStore.facultyPageStore.authorPageData.proposalData;
        const facultyName = this.props.first_name + " " + this.props.last_name  + "'s" ;
        
        let countLabel;

        if(this.state.showCount){
            countLabel = "count "
        }else{
            countLabel = ""
        }

        let trendChartData;
        if(this.state.showCount){
            trendChartData = proposalsData.proposals_over_time.data.map(this.buildStackedTrendItemCount).sort(this.sortTrendItem)
        }else{
            trendChartData = proposalsData.proposals_over_time.data.map(this.buildStackedTrendItemAmount).sort(this.sortTrendItem)
        }

        const trendChart = <StackedTrendChart 
                            state={proposalsData.proposals_over_time.requestState}
                            data={trendChartData}
                            error={proposalsData.proposals_over_time.error}
                            title={`${facultyName} Proposals ${countLabel}over time`}
                            onTrendBarClick={this.onTrendBarClick}
                            onTrendSelectionCleared={this.onTrendBarCleared}
                            labelName={"Year"}
                            value1Label={"As PI"}
                            value2Label={"As Co-PI"}
                            value3Label={"Other"}
                            value4Label={"Total"}
                            valueFormatter={this.formatValues}
                            verticalTickFormatter={this.tickFormatter}
                            showToggle={true}
                            isToggleOn={this.state.showCount}
                            toggleLabel={"Amount"}
                            toggleLabel2={"Count"}
                            onToggleStateChanged={this.onToggleStateChanged}
                            initStartYear={this.state.startYear}
                            initEndYear={this.state.endYear}
                            onRangeChanged={this.onRangeChanged}
                            />

        return (
            <div id="overview" className={css(styles.overview)} >

                {trendChart}

                <CombinedInfo author_id={this.props.author_id} startYear={this.state.startYear} endYear={this.state.endYear} />

            </div>
        );
    }

    public renderCharts = () => {
        const proposalsData = appStore.facultyPageStore.authorPageData.proposalData;
        
        let projectTitle;
        let projectToolTip;
        let departmentTitle;
        let departmentToolTip;
        const facultyName = this.props.first_name + " " + this.props.last_name  + "'s" ;
        const startYear = this.state.startYear;
        const endYear = this.state.endYear

        if(this.state.selectedYear === 0 ){
            projectTitle = `${facultyName} Proposal by Funding Agency FY ${startYear} to FY ${endYear}`;
            projectToolTip = `${startYear} to ${endYear} (as reported on scopus.com)`;
            departmentTitle = `${facultyName} Proposal by Unit from FY ${startYear} to FY ${endYear}`;
            departmentToolTip = `For top 10 cited since FY ${startYear} to FY ${endYear} (as reported on scopus.com)`;
        }else{
            projectTitle = `${facultyName} Proposal by Funding Agency for Year: FY ${this.state.selectedYear}`;
            projectToolTip = `Year: FY ${this.state.selectedYear} (as reported on scopus.com)`;
            departmentTitle = `${facultyName} Proposal by Unit for Year: FY ${this.state.selectedYear}`;
            departmentToolTip = `For top 10 cited in ${this.state.selectedYear} (as reported on scopus.com)`;
        }


        let funding_agency_data;
        let department_data;

        if(this.state.showCount){
            funding_agency_data =  proposalsData.proposals_by_fundingagency.data.slice()
                                    .sort(this.sortFundingAgencyItemCount)
                                    .map(this.buildStackChartItemFromFAItemCount)
                                    .slice(0,10)
            department_data =  proposalsData.proposals_by_department.data.slice()
                                    .sort(this.sortDepartmentItemCount)
                                    .map(this.buildStackChartItemFromDepItemCount)
                                    .slice(0,10)
        }else{
            funding_agency_data =  proposalsData.proposals_by_fundingagency.data.slice()
                                    .sort(this.sortFundingAgencyItemAmount)
                                    .map(this.buildStackChartItemFromFAItemAmount)
                                    .slice(0,10)
            department_data =  proposalsData.proposals_by_department.data.slice()
                                    .sort(this.sortDepartmentItemAmount)
                                    .map(this.buildStackChartItemFromDepItemAmount)
                                    .slice(0,10)
        }

        const funding_agency_chart = (
            <StackedHorizontalBarChart id="funding_agency"
                state={proposalsData.proposals_by_fundingagency.requestState}
                data={funding_agency_data}
                error={proposalsData.proposals_by_fundingagency.error}
                title={projectTitle}
                tooltip={projectToolTip}
                labelName={"Funding Agency"}
                value1Label={"As PI"}
                value2Label={"As Co-PI"}
                value3Label={"Other"}
                value4Label={"Total"}
                valueFormatter={this.formatValues}
                onExpandClick={this.onProjectExpandClick}
                onItemClick={this.onProjectClick}
                tickFormatter={this.tickFormatter}
                />
        )
        const department_chart = (
            <StackedHorizontalBarChart id="department"
                state={proposalsData.proposals_by_department.requestState}
                data={department_data}
                error={proposalsData.proposals_by_department.error}
                title={departmentTitle}
                tooltip={departmentToolTip}
                labelName={"Unit"}
                value1Label={"As PI"}
                value2Label={"As Co-PI"}
                value3Label={"Other"}
                value4Label={"Total"}
                valueFormatter={this.formatValues}
                onExpandClick={this.onProjectExpandClick}
                onItemClick={this.onProjectClick}
                tickFormatter={this.tickFormatter}
                />
        )

        return (
            <div id="charts_container" className={css(styles.charts_container)} >
                    {funding_agency_chart}        
                    {department_chart}
                    {this.buildProposalList(appStore.facultyPageStore.authorPageData.proposalData.proposals_list, this.state.selectedYear)}   
            </div>
        )
    }

    private buildProposalList = (chartStore: ChartStore<ProposalListItem>, selectedYear: number) => {
        let label;
        const facultyName = this.props.first_name + " " + this.props.last_name  + "'s" ;
        if(selectedYear === 0){
            label = `${facultyName} Proposals`;
        }else{
            label = `${facultyName} Proposals for Year: FY ${selectedYear}`
        }

        let content;

        if(chartStore.requestState === RequestState.SUCCESS){
            content = (
                <React.Fragment>
                    <ListGroup flush={true} className={css(styles.awardsList)} >
                        {chartStore.data.map(this.buildProposalListItem)}
                    </ListGroup>
                </React.Fragment>
            );
        }else if(chartStore.requestState === RequestState.LOADING){
            content = (
                <div style={{padding: 100}} >
                    Loading
                </div>
            )
        }else if(chartStore.requestState === RequestState.ERROR){
            content = (
                <div style={{padding: 100}}>
                    {chartStore.error}
                </div>
            )
        }else{
            content = (
                <div>

                </div>
            );
        }

        return (
            <Card id="proposals" className={css(styles.card, styles.awardsCard)}>
                <CardHeader className={css(styles.publicationCardHeader)} >
                    <div>
                        {label}
                    </div>
                </CardHeader>
                <CardBody className={css(styles.awardsBody)} >
                    {content}
                </CardBody>
            </Card>
        );
    }

    private buildProposalListItem = (item: ProposalListItem, index: number) => {
        return (<ListGroupItem key={index} onClick={(event: any)=> {this.onProposalClick(item)}} >
                <div  style={{minWidth: "100%"}} >
                    <h6>
                        <div className={css(styles.publicationTitle)}>
                            {item.title}
                        </div>
                    </h6>
                    <div style={{ fontSize: "12px" }}>
                        {this.buildParticipants(item.projects)}
                    </div>
                    <div style={{ fontSize: "10px" }} >
                        {item.agency}, {item.begin_date}
                    </div>
                </div>
        </ListGroupItem>);
    }

    private onProposalClick = (clickedAward: ProposalListItem) => {
        this.setState({...this.state, isProposalDialogOpen: true, clickedProposalListItem: clickedAward})
    }

    private buildParticipants = (projects: ProposalProjectItem[]): string => {
        let participants : ProposalParticipant[] = [];
        for(const project of projects){
            participants = participants.concat(project.participants);
        }
        
        let data;
        if(participants.length > 10){
            data = participants.slice(0,10);
        }else{
            data = participants;
        }

        const combinedNames = data.map((author: ProposalParticipant)=>{
            return author.first_name + " " + author.last_name; 
        })

        const coauthor_str = combinedNames.join(", ")
        return coauthor_str;
    }

    private onProjectClick = (chartItem: ChartItem ) => {
        const newState = {...this.state, isProjectDetailDialogOpen: true, clickedProjectID: "34342"};
        this.setState(newState);
    }

    private buildProjectDetailDialog = () => {
        return (
            <div>

            </div>
        );
    }

    private onRangeChanged = (startYear: number, endYear: number) => {
        this.setState({...this.state, startYear: startYear, endYear: endYear});
        this.fetchDataForRange(startYear, endYear);
    }
        
    private onProjectDetailClose = () => {
        const newState = {...this.state, isProjectDetailDialogOpen: false, clickedProjectID: ""};
        this.setState(newState);
    }


    private onProjectExpandClick = () => {
        const newState = {...this.state, isProjectExpanded: true};
        this.setState(newState);
    }

    private buildProjectExpandDialog = () => {
        return (
             <div>

             </div>
        );
    }

    private onProjectClose = () => {
        const newState = {...this.state, isProjectExpanded: false};
        this.setState(newState);
    }
   

    private onDepartmentExpandClick = () => {
        const newState = {...this.state, isDepartmentExpanded: true};
        this.setState(newState);
    }

    private buildDepartmentExpandDialog = () => {
        return (
            <div>

            </div>
        );
    }

    private onDepartmentClose = () => {
        const newState = {...this.state, isDepartmentExpanded: false};
        this.setState(newState);
    }
    
    public formatValues = (value: string) => {
        if(this.state.showCount){
            return value;
        }else{
            return "$"+ millify(+value);
        }
        
    }

    private tickFormatter = (value: string) => {
        if(this.state.showCount){
            return value;
        }else{
            return "$"+ millify(+value);
        }
    }

    private buildFundingAgencyItem = (data: any) => {
        const label = data.name;
        const value = data.count;
        return new ChartItem(label,value,data.id);
    }

    private buildDepartmentChartItem = (data: any) => {
        const label = data.name;
        const value = data.count;
        return new ChartItem(label,value,data.id);
    }


    private toggleModal = () => {
        this.setState({...this.state, modal: !this.state.modal})
    }

    private onTrendBarClick = (entry: TrendItem,index: number) => {
        this.setState({...this.state, isTrendBarSelected: true, selectedYear: entry.year});   
        this.fetchData(entry.year)
    }

    private onTrendBarCleared = () => {
        this.setState({...this.state,isTrendBarSelected: false, selectedYear: 0});
        this.fetchData(0)
    }

    private onToggleStateChanged = (isToggleOn: boolean) => {
        this.setState({...this.state, showCount: isToggleOn});
    }

    private buildStackedTrendItemAmount = (item: ProposalTrendItem) : StackedTrendItem => {
        const trendItem = new StackedTrendItem();
        trendItem.year = item.year;
        trendItem.amount1 = item.pi_amount;
        trendItem.amount2 = item.co_pi_amount;
        trendItem.amount3 = item.other_amount;
        trendItem.amount4 = item.total_amount;
        return trendItem;
    }

    private buildStackedTrendItemCount = (item: ProposalTrendItem) : StackedTrendItem => {
        const trendItem = new StackedTrendItem();
        trendItem.year = item.year;
        trendItem.amount1 = item.pi_count;
        trendItem.amount2 = item.co_pi_count;
        trendItem.amount3 = item.other_count;
        trendItem.amount4 = item.total_count;
        return trendItem;
    }

    private sortTrendItem = (item1: {year: number},item2: {year: number}) => {
        return item1.year - item2.year;
    }

    private sortFundingAgencyItemAmount = (item1: ProposalByFundingAgencyItem, item2: ProposalByFundingAgencyItem) => {
        return item2.pi_amount - item1.pi_amount;
    }

    private sortFundingAgencyItemCount = (item1: ProposalByFundingAgencyItem, item2: ProposalByFundingAgencyItem) => {
        return item2.pi_count - item1.pi_count;
    }

    private sortDepartmentItemAmount = (item1: ProposalByDepartmentItem, item2: ProposalByDepartmentItem) => {
        return item2.pi_amount - item1.pi_amount;
    }

    private sortDepartmentItemCount = (item1: ProposalByDepartmentItem, item2: ProposalByDepartmentItem) => {
        return item2.pi_count - item1.pi_count;
    }

    private buildStackChartItemFromFAItemAmount = (data: ProposalByFundingAgencyItem) : StackedChartItem => {
        const item = new StackedChartItem();
        const abbr_item = new AbbreviationItem();
        abbr_item.name = data.name;
        abbr_item.name_abbr = data.name_abbr;
        item.name = JSON.stringify(abbr_item);
        item.amount1 = data.pi_amount;
        item.amount2 = data.co_pi_amount;
        item.amount3 = data.other_amount;
        item.amount4 = data.total_amount;
        item.payload = data.id;
        return item;
    }

    private buildStackChartItemFromFAItemCount = (data: ProposalByFundingAgencyItem) : StackedChartItem => {
        const item = new StackedChartItem();
        const abbr_item = new AbbreviationItem();
        abbr_item.name = data.name;
        abbr_item.name_abbr = data.name_abbr;
        item.name = JSON.stringify(abbr_item);
        item.amount1 = data.pi_count;
        item.amount2 = data.co_pi_count;
        item.amount3 = data.other_count;
        item.amount4 = data.total_count;
        item.payload = data.id;
        return item;
    }

    private buildStackChartItemFromDepItemAmount = (data: ProposalByDepartmentItem) : StackedChartItem => {
        const item = new StackedChartItem();
        const abbr_item = new AbbreviationItem();
        abbr_item.name = data.name;
        abbr_item.name_abbr = data.name_abbr;
        item.name = JSON.stringify(abbr_item);
        item.amount1 = data.pi_amount;
        item.amount2 = data.co_pi_amount;
        item.amount3 = data.other_amount;
        item.amount4 = data.total_amount;
        item.payload = data.id;
        return item;
    }

    private buildStackChartItemFromDepItemCount = (data: ProposalByDepartmentItem) : StackedChartItem => {
        const item = new StackedChartItem();
        const abbr_item = new AbbreviationItem();
        abbr_item.name = data.name;
        abbr_item.name_abbr = data.name_abbr;
        item.name = JSON.stringify(abbr_item);
        item.amount1 = data.pi_count;
        item.amount2 = data.co_pi_count;
        item.amount3 = data.other_count;
        item.amount4 = data.total_count;
        item.payload = data.id;
        return item;
    }

    private buildProposalDetailDialog = () => {
        return (<ProposalDetailDialog isOpen={this.state.isProposalDialogOpen}
                                         onClose={this.onProposalDialogClose}
                                         data={this.state.clickedProposalListItem}/>)
    }

    private onProposalDialogClose = () => {
        const newState = {...this.state, isProposalDialogOpen: false};
        this.setState(newState);
    }
        
}




// WEBPACK FOOTER //
// ./src/components/AuthorProposals.tsx